import React from 'react'
import { MenuItem, Box, Typography } from '@mui/material'
import AccountCircle from '@mui/icons-material/AccountCircle'
import { styled } from '@mui/material/styles'

const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
  padding: '12px 20px',
  borderRadius: '10px',
  margin: '4px 8px',
  transition: 'all 0.2s ease',
  '&:hover': {
    background: 'linear-gradient(135deg, rgba(116, 80, 170, 0.08) 0%, rgba(116, 80, 170, 0.04) 100%)',
  },
  '&:first-of-type': {
    marginTop: 8,
  },
  '&:last-of-type': {
    marginBottom: 8,
  },
}))

export default function ClinicAssistantProfileMenuItem({ onClick }) {
  return (
    <MenuItemStyled
      onClick={onClick}
      sx={{
        color: '#7450aa',
        '&:hover': {
          background: 'rgba(116, 80, 170, 0.08)',
        },
      }}
    >
      <Box display="flex" alignItems="center" gap={1.5}>
        <AccountCircle sx={{ fontSize: 18, color: '#7450aa' }} />
        <Typography variant="body2" fontWeight={600} sx={{ color: '#7450aa' }}>
          View Profile
        </Typography>
      </Box>
    </MenuItemStyled>
  )
}

